import { createRoute } from "../../utils";

import { achievementManagementRoutesObj, achievementBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const achievementRouteMetadata: IRouteMetadataObj<
  typeof achievementManagementRoutesObj
> = {
  list: {
    title: "achievementManagement",
    lazy: () => import("@/pages/facultyMemberPanel/achievement/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewAchievement",
    lazy: () => import("@/pages/facultyMemberPanel/achievement/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editAchievementOf",
    lazy: () => import("@/pages/facultyMemberPanel/achievement/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewAchievementOf",
    lazy: () => import("@/pages/facultyMemberPanel/achievement/form/page"),
    mode: "view",
    permission,
  },
};

export const achievementRoutes = createRoute<
  typeof achievementManagementRoutesObj
>(
  achievementManagementRoutesObj,
  achievementRouteMetadata,
  achievementBreadcrumbs,
);
